/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// reactstrap components
import {
  Button,
  Card,
  CardTitle,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  Form,
  Input,
  Row,
  Col
} from "reactstrap";

import Iframe from 'react-iframe'

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class User extends React.Component {
  constructor(props){
    super(props);
    this.state = {
        password: "",
        newPassword: "",
        registerConfirmPassword: "",
        passwordState: "",
        newPasswordState: "",
        registerConfirmPasswordState: "",
        classes: "dropdown",
        darkMode: true,
        alert: null,
        userId: "",
        userIdState: "",
        userId_isValidated: null,
    };
  }

  componentDidMount() {
    const { user_info, user } = this.props;
    console.log(user_info ? user_info.user_id : null, user)
    this.setState({userId: user_info ? user_info.user_id : ""});
  }

  
  render() {
    return (
      <>
        <div className="content">
            <Iframe url="https://se-main-gqi6flraoa-uc.a.run.app/se/docs"
                width="100%"
                // height="535px"
                className="docs"
                display="initial"
                position="relative"
            />
        </div>
      </>
    );
  }
}

function mapStateToProps({user}){
  const user_info = user && user.user_logged ? user.user_logged : null;
  // const user_api_token = user && user.api_token ? user.api_token : null;
  return{
      user_info,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      {  }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(User);